import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, Button } from 'antd';
import './styles.less';

const ModifyModal = ({ visible, onClose }) => (
  <div className="modifyModal">
    <Modal width={400} onOk={onClose} visible={visible} onCancel={onClose} footer={null}>
      <p className="modifyModal__info">
        Si modificas o agregas información se solicitará volver a firmar el contrato. ¿Deseas
        modificar los datos existentes?
      </p>
      <Row justify="center">
        <Col span={24}>
          <Row justify="center">
            <Col lg={8}>
              <Button className="modifyModal__button" type="primary" ghost onClick={onClose}>
                Cancelar
              </Button>
            </Col>
            <Col lg={12} offset={1}>
              <Button className="modifyModal__button" type="primary">
                Modificar datos
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  </div>
);

ModifyModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.func.isRequired,
};

export default ModifyModal;
